import { useEffect, useState } from "react";
import EnterpriseService from "../../common/services/enterprise-service";
import CustomBadge from "../ui/CustomBadge";
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import classNames from "classnames";
import UserDefinedUnits from "../../common/utils/UserDefinedUnits";

export default function ValidCompanyAchievementsWithCompletion({
  container,
  company,
}) {
  const [achievements, setValidAchievements] = useState([]);
  const es = new EnterpriseService();
  const [currentTab, setCurrentTab] = useState("weekly");

  useEffect(() => {
    getValidAchievements();
  }, []);

  const getWeeklyAchievements = () => {
    return achievements.filter(
      (m) => m.period === "weekly" || m.period === "recurring_weekly"
    );
  };

  const getMonthlyAchievements = () => {
    return achievements.filter(
      (m) => m.period === "monthly" || m.period === "recurring_monthly"
    );
  };

  const getYearlyAchievements = () => {
    return achievements.filter(
      (m) => m.period === "yearly" || m.period === "recurring_yearly"
    );
  };

  const getValidAchievements = async () => {
    try {
      const response = await es.getValidCompanyAchievementsWithCompletion(
        company.id
      );
      if (response) {
        setValidAchievements(response);
      }
    } catch (error) {
      console.error("Error fetching valid achievements:", error);
    }
  };

  const renderAchievementCards = (achievements) => {
    return achievements.map((element) => {
      return (
        <div className="mb-2">
          <div className="d-flex align-items-center flex-row">
            <div className="d-flex flex-column flex-grow-1">
              <div className="fs-5">{element.computed_title}</div>
              {element.story != null && element.story != "" && (
                <div className="my-3 fs-7">{element.story}</div>
              )}
              <div className="mt-1 w-100">
                <div class="h-30px bg-secondary relative">
                  {element.completion != null &&
                    element.completion.length > 0 && (
                      <>
                        {element.completion.map((c) => {
                          let percentage =
                            (c.current_value / element.control_value) * 100;
                          if (percentage > 100) percentage = 100;

                          return (
                            <>
                              <UncontrolledTooltip
                                target={`achievement-user-${element.id}-${c.user.id}`}
                              >
                                {c.user.name} - {c.current_value} / {element.control_value} - {percentage.toFixed(0)}%
                              </UncontrolledTooltip>
                              <img
                                id={`achievement-user-${element.id}-${c.user.id}`}
                                src={c.user.avatar_url}
                                className="rounded-circle avatar-xs position-absolute h-30px"
                                style={{
                                  left: `${percentage}%`,
                                  transform: "translateX(-50%)",
                                }}
                              />
                            </>
                          );
                        })}
                      </>
                    )}
                </div>
                <div className="mt-1 w-100 d-flex justify-content-between text-gray-600">
                  <span>0</span>
                  <span>
                    {container.localeManager
                      .numeral(element.control_value)
                      .format()}
                  </span>
                </div>
              </div>
            </div>
            {element.points != null && element.points > 0 && (
              <div className="w-150px text-end">
                <span className="fs-4 points">
                  {container.localeManager.formatString(
                    container.localeManager.strings.pointsFormatted,
                    element.points
                  )}
                </span>
              </div>
            )}
          </div>
          <div className="mt-2">
            {element.game_id == null && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.allGames}
              </CustomBadge>
            )}
            {element.game_id == 1 && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                ETS2
              </CustomBadge>
            )}
            {element.game_id == 2 && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                ATS
              </CustomBadge>
            )}
            {element.game_mode == null && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.allGameModes}
              </CustomBadge>
            )}
            {element.game_mode == "sp" && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings[element.game_mode]}
              </CustomBadge>
            )}
            {element.game_mode == "tmp" && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                TruckersMP
              </CustomBadge>
            )}
            {element.max_damage == 0 && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.noDamage}
              </CustomBadge>
            )}
            {element.is_wotr && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.onlyWotrJobs}
              </CustomBadge>
            )}
            {element.owned_trailer && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.onlyOwnedTrailer}
              </CustomBadge>
            )}
            {element.market != null && element.market.length > 0 && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings[element.market]}
              </CustomBadge>
            )}
            {element.min_job_length_km != null && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.formatString(
                  container.localeManager.strings.minimumDistance,
                  UserDefinedUnits.convertDistance(
                    container.dataService.enterpriseService.member,
                    element.game_id,
                    element.min_job_length_km
                  )
                )}
              </CustomBadge>
            )}
            {element.stats_type != null && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings[element.stats_type]}
              </CustomBadge>
            )}
            {element.special_job && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.specialJobs}
              </CustomBadge>
            )}
            {element.manual_parking && (
              <CustomBadge
                light={false}
                color="light-warning"
                size="sm"
                className="me-2"
              >
                {container.localeManager.strings.manualParking}
              </CustomBadge>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      {achievements && achievements.length > 0 && (
        <Card className="my-3 bordered mx-0">
          <CardBody>
            <h3>{container.localeManager.strings.achievements}</h3>
            <Nav
              className="nav-custom nav-line-tabs nav-line-tabs-2x fs-6 fw-bold mb-3"
              tabs
            >
              {getWeeklyAchievements().length > 0 && (
                <NavItem>
                  <NavLink
                    className={classNames({ active: currentTab === "weekly" })}
                    onClick={() => {
                      setCurrentTab("weekly");
                    }}
                  >
                    {container.localeManager.strings.weekly}
                  </NavLink>
                </NavItem>
              )}
              {getMonthlyAchievements().length > 0 && (
                <NavItem>
                  <NavLink
                    className={classNames({ active: currentTab === "monthly" })}
                    onClick={() => {
                      setCurrentTab("monthly");
                    }}
                  >
                    {container.localeManager.strings.monthly}
                  </NavLink>
                </NavItem>
              )}
              {getYearlyAchievements().length > 0 && (
                <NavItem>
                  <NavLink
                    className={classNames({ active: currentTab === "yearly" })}
                    onClick={() => {
                      setCurrentTab("yearly");
                    }}
                  >
                    {container.localeManager.strings.yearly}
                  </NavLink>
                </NavItem>
              )}
            </Nav>
            <TabContent activeTab={currentTab}>
              <TabPane tabId="weekly">
                {renderAchievementCards(getWeeklyAchievements())}
              </TabPane>
              <TabPane tabId="monthly">
                {renderAchievementCards(getMonthlyAchievements())}
              </TabPane>
              <TabPane tabId="yearly">
                {renderAchievementCards(getYearlyAchievements())}
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      )}
    </>
  );
}
